module.exports = __webpack_public_path__ + "static/media/truck3.09b98880.jpeg";